import { render, staticRenderFns } from "./IconShow.vue?vue&type=template&id=2dc93b2c&scoped=true"
import script from "./IconShow.vue?vue&type=script&lang=js"
export * from "./IconShow.vue?vue&type=script&lang=js"
import style0 from "./IconShow.vue?vue&type=style&index=0&id=2dc93b2c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc93b2c",
  null
  
)

export default component.exports